import React from 'react';

import { useNavigate } from 'react-router-dom';

import { DarkLogoCyclone } from '@/shared/assets/images';
import { Icon } from '@/shared/ui/Icon';

import styles from './HeaderLeft.module.css';

type HeaderLeftProps = {
  collapsed?: boolean;
  onToggleSidebar?: () => void;
};

export const HeaderLeft = React.memo(({ collapsed = false, onToggleSidebar = () => {} }: HeaderLeftProps) => {
  const navigate = useNavigate();

  const handleToggleSidebar = () => {
    if (onToggleSidebar) {
      onToggleSidebar();
    }
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <div className={styles.leftSection}>
      <button className={styles.sidebarToggle} onClick={handleToggleSidebar}>
        {collapsed ? <Icon name="nav-fold" /> : <Icon name="nav-unfold" />}
      </button>

      <div className={styles.logo} onClick={handleLogoClick}>
        <DarkLogoCyclone className={styles.logoIcon} />
      </div>
    </div>
  );
});

HeaderLeft.displayName = 'HeaderLeft';
